import {Component, OnInit} from '@angular/core';
import {DialogHeaderComponent} from '@reusable/dialog-header/dialog-header.component';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonComponent} from '../button/button.component';
import {interval, Subject, takeUntil} from 'rxjs';
import {AuthenticationHelperService} from '@auth/authentication-helper.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {SidebarService} from '@services/sidebar.service';
import {LocalStorageService} from '@services/local-storage.service';
import {tap} from 'rxjs/operators';
import {AutoLogoutService} from './autologout.service';
import {LOGOUT_TIMEOUT, LOGOUT_TIMER_TIMEOUT} from './constants';

@Component({
  template: `
      <app-dialog-header [title]="'Confirm Action'|translate" [close]="false"></app-dialog-header>
      <div class="modal-body d-flex flex-column align-items-center">
          <h4 class="text-black">You have been away for the past 10 minutes</h4>
          <h3>{{ timeLeft }} </h3>
          <h3>seconds to auto logout</h3>
      </div>
      <div class="modal-footer">
          <app-button (click)="imhere()">{{'i am here'|translate}}</app-button>
          <app-button (click)="logout()" variant="warning">{{'logout now'|translate}}</app-button>
      </div>
  `,
  standalone: true,
  imports: [
    DialogHeaderComponent,
    TranslateModule,
    ButtonComponent
  ]
})
export class LogoutTimerComponent implements OnInit {
  logoutAfter: number;
  timeLeft: number;
  timerStop: Subject<void> = new Subject<void>();

  constructor(
    private authenticationHelperService: AuthenticationHelperService,
    private modalRef: BsModalRef,
    private autoLogoutService: AutoLogoutService,
    private sidebarService: SidebarService,
    private localStorageService: LocalStorageService,
  ) {
  }

  ngOnInit() {
    this.timeLeft = Math.floor(this.logoutAfter / 1000);
    interval(1000).pipe(
      takeUntil(this.timerStop),
      tap(() => {
        this.timeLeft = Math.floor((
          LOGOUT_TIMER_TIMEOUT + LOGOUT_TIMEOUT - (new Date().getTime() - this.localStorageService.getLastEventTime())
        ) / 1000);
        if (this.timeLeft <= 0) {
          this.logout();
        }
      }),
    ).subscribe();
  }

  stopTimerAndHide() {
    this.timerStop.next();
    this.modalRef.hide();
  }

  imhere() {
    this.stopTimerAndHide();
    // reload client list to refresh session
    this.sidebarService.reloadClientsList();
    this.autoLogoutService.reset();
  }

  logout() {
    this.stopTimerAndHide();
    this.authenticationHelperService.logout();
  }
}